import { PropsWithChildren } from "react";

interface ColumnResizerProps
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLDivElement> {
  isResizing: boolean;
}

export const ColumnResizer = ({
  children,
  isResizing,
  ...props
}: ColumnResizerProps) => {
  return (
    <div
        // className={`block absolute top-0 right-0 w-1 h-full ${isResizing ? 'bg-[#BC3BE9]' : 'bg-[#D893F2]'} cursor-col-resize select-none touch-none opacity-0 transition-all duration-300 hover:opacity-100`}
        {...props}
    >
      {children}
    </div>
  );
};
